import React from 'react'
import './lease.css'
import Navbar from './../../components/navbar/Navbar';
import Hero from './../../components/hero/Hero';

const Lease = () => {
  return (
    <>
      <Navbar/>
      <Hero title="Our Lease Plan"/>
    </>
  )
}

export default Lease